<template>
  <div class="question" v-if="item">
    <form class="question-container" @submit.prevent="save">
      <div class="tab-item-header">
        <NoticeBox type="info">
          回答完了後、完了タブで「回答を送信して閉じる」押下をお願い致します。
        </NoticeBox>
      </div>
      <header class="question-header">
        <h2 class="question-title">
          <span class="question-num" v-if="order">Q{{ order }}</span>
          <div class="u-pre-wrap" v-html="$domUtils.decode($domUtils.nl2br(item.question_title))"></div>
        </h2>
        <hr class="question-divider mobile-only" />
        <figure class="question-image tablet-only" v-if="item.question_image">
          <img :src="item.question_image" :alt="item.question_title" />
        </figure>
      </header>
      <div class="question-body" ref="scrolling">
        <figure class="question-image mobile-only" v-if="item.question_image">
          <img :src="item.question_image" :alt="item.question_title" />
        </figure>
        <hr class="question-divider tablet-only" />
        <div class="question-content">
          <p class="question-note" v-html="$domUtils.decode($domUtils.nl2br(item.comment))" />
          <NoticeBox type="error" v-if="errorMessage">
            {{ errorMessage }}
          </NoticeBox>
          <div class="question-input">
            <template v-if="item.isText">
              <div class="form-group space-b-0">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$domUtils.decode(item.placeholder)"
                  v-model="item.answer"
                  maxlength="255"
                />
              </div>
            </template>
            <template v-if="item.isTextarea">
              <div class="form-group space-b-0">
                <textarea
                  class="form-control is-multiline"
                  :placeholder="$domUtils.decode(item.placeholder)"
                  v-model="item.answer"
                  maxlength="1000"
                  :rows="item.answer.split(/\n/).length"
                />
              </div>
            </template>
            <template v-if="item.isDate">
              <div class="form-group space-b-0">
                <YearMonthDateSelect v-model="item.answer" :years="years" />
              </div>
            </template>
            <template v-if="item.isCheck">
              <QuestionCheckBlockList
                :items="item.select_option"
                :single="item.isCheckSingle"
                v-model="item.answer"
              />
            </template>
            <template v-if="item.isCheckImage">
              <QuestionCheckBlockList
                :has-image="true"
                :items="item.select_option"
                :single="item.isCheckSingle"
                v-model="item.answer"
              />
            </template>
            <template v-if="item.isImage">
              <Uploader v-model="item.answer" @error="onUploadError" />
            </template>
          </div>
        </div>
        <footer class="question-footer">
          <WaveButton type="submit" :loading="loading">保存して次へ</WaveButton>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import NoticeBox from '@/components/NoticeBox.vue'
import QuestionCheckBlockList from '@/components/QuestionCheckBlockList.vue'
import YearMonthDateSelect from '@/components/YearMonthDateSelect.vue'
import Uploader from '@/components/Uploader.vue'
import api from '@/api/after-survey'
import { getQuestionYears } from '@/utils/form'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    order: {
      type: Number,
      required: false
    }
  },

  components: {
    NoticeBox,
    Uploader,
    YearMonthDateSelect,
    QuestionCheckBlockList,
  },

  data() {
    return {
      answer: null,
      years: [],
      loading: false,
      errorMessage: '',
      revision: 0
    }
  },

  computed: {
    businessId() {
      return this.$store.getters['auth/businessId']
    }
  },

  methods: {
    async save() {
      this.errorMessage = ''

      if (!this.item.validate()) {
        this.errorMessage = this.item.error
        this.$refs.scrolling.scrollTop = 0
        return false
      }

      this.loading = true

      try {
        await api.answer(this.businessId, this.item.id, this.item.answerParam)

        this.item.updateAnswer()

        this.$emit('saved', this.item.id)
      } catch(err) {
        this.$emit('error', err)
      } finally {
        this.loading = false
      }
    },
    onUploadError(message) {
      this.errorMessage = message
    }
  },

  created() {
    this.years = getQuestionYears()
  }
}
</script>
